import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);

  const lang = (i18n.language || 'en').split('-')[0];
  const getName = (name: { en: string; pl: string; es: string; fr: string }) =>
    name[lang as 'en' | 'pl' | 'es' | 'fr'] || name.en;

  return (
    <div className="relative w-full sm:w-auto">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 sm:w-auto"
      >
        <span className="flex items-center gap-2">
          <span className="flex h-5 w-5 items-center justify-center text-primary-600">
            <i className="ri-layout-grid-line text-lg"></i>
          </span>
          <span>{t('home.categoryDropdownLabel')}</span>
        </span>
        <span className="flex h-5 w-5 items-center justify-center">
          <i className={`text-lg ${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
        </span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute left-0 z-20 mt-2 max-h-96 w-full overflow-auto rounded-lg border border-background-200 bg-background-50 py-1 sm:w-72">
            {categories.map((c) => (
              <a
                key={c.slug}
                href={c.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 whitespace-nowrap px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                  <i className="ri-arrow-right-up-line text-base"></i>
                </span>
                <span>{getName(c.name)}</span>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
}